// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__vARQL","p":"Settings_p__r7vUf"};